import { getLocaleNamespace } from '@wix/wixstores-multilingual-adapter/dist/src/locale-namespace';
var MultilingualService = /** @class */ (function () {
    function MultilingualService(publicData, widgetSettings, multiLangFields, defaultLocale) {
        this.publicData = publicData;
        this.widgetSettings = widgetSettings;
        this.multiLangFields = multiLangFields;
        this.defaultLocale = defaultLocale;
        if (multiLangFields) {
            this.isPrimaryLanguage = this.multiLangFields.isPrimaryLanguage;
            this.lang = this.multiLangFields.lang;
        }
        else {
            this.isPrimaryLanguage = true;
            this.lang = this.defaultLocale;
        }
    }
    MultilingualService.prototype.get = function (key) {
        if (this.isPrimaryLanguage) {
            return this.publicData[key];
        }
        else {
            var widgetSettingsTextsMap = this.widgetSettings[getLocaleNamespace(this.lang)];
            return widgetSettingsTextsMap && widgetSettingsTextsMap[key];
        }
    };
    return MultilingualService;
}());
export { MultilingualService };
//# sourceMappingURL=multilingualService.js.map